import { render, staticRenderFns } from "./ASC_ByReasonPrintable.vue?vue&type=template&id=010c485e&scoped=true&"
import script from "./ASC_ByReasonPrintable.vue?vue&type=script&lang=js&"
export * from "./ASC_ByReasonPrintable.vue?vue&type=script&lang=js&"
import style0 from "./ASC_ByReasonPrintable.vue?vue&type=style&index=0&id=010c485e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c485e",
  null
  
)

export default component.exports